import { FC, useMemo } from "react";
import { Point, YAxisOptions } from "highcharts";
import numeral from "numeral";
import { HighchartsChartDataType } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import { InlineHighcharts } from "@/storybook/c8r-inline-highcharts/InlineHighcharts";

interface BillingCostChartProps {
  chartData: HighchartsChartDataType;
}

export const BillingCostChart: FC<BillingCostChartProps> = ({ chartData }) => {
  const tooltipMarkupGenerator = useMemo(
    () => getTooltipValueFormatter(chartData),
    [chartData],
  );

  return (
    <InlineHighcharts
      yAxis={yAxis}
      pointWidth={6}
      boxHeight={27}
      chartHeight={35}
      chartData={chartData}
      plotOptions={plotOptions}
      tooltipMarkupGenerator={tooltipMarkupGenerator}
    />
  );
};

const yAxis: YAxisOptions = {
  visible: false,
};

const getTooltipValueFormatter =
  (chartData: HighchartsChartDataType) => (point: Point) => {
    const index = point.index ?? 0;
    const value = chartData?.series?.at?.(0)?.data?.[index]?.y ?? null;

    return `
    <div style="font-size: 12px; color: #666; margin-bottom: 8px; min-width: 170px;">${formatDate(String(point.category), { type: "date" })}</div>  
      <div style="display: flex; flex-direction: column; gap: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
            <span style="display: flex; align-items: center; font-size: 12px; margin-right: 16px;">
                <span style="font-weight: 500;  border-left: 3px solid ${color}; padding-left: 8px;">
                    ${point?.series?.name}
                </span>
            </span>

          <span style="font-weight: bold; font-size: 12px; "> ${value === null ? "N/A" : numeral(value).format("$0,0.[00]")}</span>
        </div>
      </div>
      `;
  };

const lighterColor = "#FF40814D";
const color = "#FF4081";

const plotOptions = {
  column: {
    pointWidth: 6,
    height: 22,
    pointPadding: 0.5,
    groupPadding: 0.5,
    borderWidth: 0,
    borderRadius: 0,
    color: lighterColor,
    minPointLength: 2,
    states: {
      hover: {
        enabled: true,
        color,
      },
    },
  },
  series: {
    animation: false,
    states: { inactive: { enabled: false } },
  },
};
